import React from 'react';
import { Editor } from 'slate';
import { Plugin, CustomEditor, CustomText } from '../types';

const StrikethroughPlugin: Plugin = {
  name: 'strikethrough',
  
  onKeyDown: (event: KeyboardEvent, editor: CustomEditor) => {
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'S') {
      event.preventDefault();
      const marks = Editor.marks(editor) as CustomText;
      const isActive = marks?.strikethrough === true;
      if (isActive) {
        Editor.removeMark(editor, 'strikethrough');
      } else {
        Editor.addMark(editor, 'strikethrough', true);
      }
      return true;
    }
    return false;
  },

  commands: {
    toggleStrikethrough: (editor: CustomEditor) => {
      const marks = Editor.marks(editor) as CustomText;
      const isActive = marks?.strikethrough === true;
      if (isActive) {
        Editor.removeMark(editor, 'strikethrough');
      } else {
        Editor.addMark(editor, 'strikethrough', true);
      }
    }
  }
};

export default StrikethroughPlugin; 